"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToRow = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
function useScrollToRow({ data, enableVirtualization, page, paginatorRenderer, scrollToRow, }) {
    const rowRefs = React.useRef({});
    // Refs prevents from having `page` and `data` as dependencies
    // therefore we avoid unnecessary scroll to row.
    const pageRef = React.useRef(page);
    pageRef.current = page;
    const dataRef = React.useRef(data);
    dataRef.current = data;
    // For virtualized tables, all we need to do is pass the index of the item
    // to the VirtualScroll component
    const scrollToIndex = React.useMemo(() => {
        if (!scrollToRow || paginatorRenderer) {
            return undefined;
        }
        const index = scrollToRow(pageRef.current, dataRef.current);
        return index < 0 ? undefined : index;
    }, [paginatorRenderer, scrollToRow]);
    // For non-virtualized tables, we need to add a ref to each row
    // and scroll to the element
    React.useEffect(() => {
        var _a;
        if (enableVirtualization ||
            scrollToIndex === undefined ||
            scrollToIndex === null ||
            scrollToIndex < 0) {
            return;
        }
        (_a = rowRefs.current[pageRef.current[scrollToIndex].id]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }, [enableVirtualization, scrollToIndex]);
    const tableRowRef = React.useCallback((row) => {
        return (element) => {
            rowRefs.current[row.id] = element;
        };
    }, []);
    return { scrollToIndex, tableRowRef };
}
exports.useScrollToRow = useScrollToRow;
